import Chart from "./Chart.component";

export default Chart;
